






































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  ComposeExam$,
  GetAllBanjis$,
  GetExamDetail$,
  GetAllTest$,
} from "@/request/jxgl";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class XsDetail extends Vue {
  private exam: any = {
    exam_id: "",
    考试名称: "",
    test_id: "",
    class_id: "",
    开始时间: "",
    结束时间: "",
  };
  private banjis: any[] = [];
  private tests: any[] = [];
  // 获得详情
  private fetchDetail() {
    const params: any = {
      params: {
        exam_id: this.$route.query.id,
      },
    };
    GetExamDetail$(this, params).then((data: any) => {
      this.$set(this, "exam", data);
    });
  }
  // 获得班级列表
  private fetchBanji() {
    GetAllBanjis$(this).then((data: any) => {
      this.banjis = data;
    });
  }
  // 获得班级列表
  private fetchTest() {
    GetAllTest$(this).then((data: any) => {
      this.tests = data;
    });
  }
  // 取消
  private cancel() {
    this.$router.back();
  }
  // 保存
  private save() {
    if (!this.exam["exam_id"]) {
      delete this.exam["exam_id"];
    }
    if (!this.exam["考试名称"]) {
      this.$message.warning("考试名称不能为空");
      return;
    }
    if (!this.exam["test_id"]) {
      this.$message.warning("管理试卷不能为空");
      return;
    }
    if (!this.exam["class_id"]) {
      this.$message.warning("所属班级不能为空");
      return;
    }
    if (!this.exam["开始时间"]) {
      this.$message.warning("开始时间不能为空");
      return;
    }
    if (!this.exam["结束时间"]) {
      this.$message.warning("结束时间不能为空");
      return;
    }
    // console.log(this.exam);
    ComposeExam$(this, this.exam).then((data: any) => {
      this.$message.success("编辑成功");
      this.$router.back();
    });
  }
  // 初始化
  private mounted() {
    this.fetchBanji();
    this.fetchTest();
    if (this.$route.query.id) {
      this.fetchDetail();
    }
  }
}
